<div class="videos">
  <div *ngFor="let video of videos; trackBy: trackByFn" class="video-container">
    <div class="video" *ngIf="!video.isExternal">
      <video
        *ngIf="video.thumbnailBlob | async as pic; else loading"
        class="video-player"
        controls
        [attr.id]="video.id"
        (play)="onPlay(video)"
        [attr.poster]="pic"
        preload="none"
      >
        <source [attr.src]="video.videoBlob" [attr.type]="video.modifiedMimeType" />
        {{ 'module.information.browserDoesNotSupportText' | translate }}
      </video>
    </div>
    <div class="video" *ngIf="video.isExternal">
      <div class="external-video" (click)="launch(video)">
        <img *ngIf="video.thumbnailBlob | async as pic; else loading" alt="thumbnail-img" class="external-thumbnail" [src]="pic" />
      </div>
    </div>
    <div class="video-details">
      <div class="video-title">
        <div class="video-name">{{ video.title }}</div>
        <div class="edit-delete">
          <span class="duration">{{ video.durationString }}</span>
          <span class="fa fa-pencil" (click)="edit(video)" *ngIf="!!authService.permissions.VIDEO_UPDATE"></span>
          <span class="fa fa-trash" (click)="delete(video)" *ngIf="!!authService.permissions.VIDEO_UPDATE"></span>
        </div>
      </div>
      <div class="video-desc" [innerHTML]="video.description"></div>
    </div>
  </div>
  <div class="no-vids">
    <app-notification-card class="app-notification-card" *ngIf="!overlayLoader.isLoading && videos.length === 0" type="info" text="Kein Beitrag verfügbar">
    </app-notification-card>
  </div>
  <ng-template #loading>
    <app-skeleton-loader></app-skeleton-loader>
  </ng-template>
</div>
